enum DateFormatDescription {
	Undefined = 0,
	Short = 1,
	Medium = 2,
	Long = 3,
	Full = 4,
	DayMonth = 5,
	MonthShortYear = 6,
	MonthYear = 7
}

export default DateFormatDescription;
